
import Vue from 'vue'
import PriceLabel from '@/components/PriceLabel.vue'
import BaseImage from '@/components/BaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/constants'
import { TopProductItem } from '@/pages/top/types'
import { BQ_EVENT_NAMES, raksulBQEventTracker} from '@/utils'

export default Vue.extend({
  name: 'ProductCard',
  components: {
    BaseImage,
    PriceLabel
  },
  props: {
    productItem: {
      type: Object as () => TopProductItem,
      required: true
    }
  },
  computed: {
     placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE_CARD
    },
    productUrl(): string {
      return `products/${this.productItem.id}`
    }
  },
  methods: {
    trackingProductClick(productId: number) {
      if (productId){
        raksulBQEventTracker({
          eventName: BQ_EVENT_NAMES.CLICK_MERCHANDISE,
          data: {
            productId: JSON.stringify([productId.toString()])
          }
        })
        location.href = `products/${productId}`
      }
    },
    quantityLabel(quantity?: number): string {
      if (!quantity || quantity == 1) return 'No minimum quantity'
      else return 'Order as few as '
    }
  }
})
